import { Button, Flex, Input, Select, TableContainer, Text, VStack } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import { Layout } from '../../../components/Layout'
import { useForm } from 'react-hook-form'
import { api } from '../../../services/api'
import { useQuery, useQueryClient } from 'react-query'
import { useSearchParams } from 'react-router-dom'
import * as T from '../../../components/Table'
import { ListHistoryRegisterProduct } from './ListHistoryRegisterProduct'

async function getUsers() {
  const response = await api.get('/orcament-produto/listar-pessoas?limit=100&ordenacao=DESC')

  return response.data
}

async function getHistoryProducts({ cod_usu, cod_prod, dt_cad, limit }) {
  const response = await api.get('/orcament-produto/listar', {
    params: {
      cod_usu,
      cod_prod,
      dt_cad,
      limit,
    },
  })

  return response.data
}

export function HistoricoCadastroProduto() {
  const [searchParams, setSearchParams] = useSearchParams()

  const queryClient = useQueryClient()

  const methods = useForm({
    defaultValues: {
      cod_usu: searchParams.get('cod_usu') || '',
      cod_prod: searchParams.get('cod_prod') || '',
    },
  })

  console.log(searchParams.get('cod_prod'))

  const { register, handleSubmit } = methods

  const { data, isLoading, refetch, isRefetching } = useQuery({
    queryKey: ['history-products', { cod_usu: searchParams.get('cod_usu'), cod_prod: searchParams.get('cod_prod'), dt_cad: '' }],
    queryFn: () => getHistoryProducts({ limit: 15, cod_usu: searchParams.get('cod_usu'), cod_prod: searchParams.get('cod_prod'), dt_cad: '' }),
    refetchOnWindowFocus: false,
  })

  const { data: users } = useQuery({
    queryKey: 'users',
    queryFn: getUsers,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  })

  async function onSubmit(data) {
    console.log('dataata', data)

    queryClient.invalidateQueries('history-products')

    setSearchParams(data)
    refetch()
  }

  console.log(data)

  return (
    <>
      <HeadingPages name="Histórico de Cadastro de Produtos" />

      <Layout>
        <VStack spacing={4} w="100%">
          <Flex maxW="xl" alignItems="flex-end" mx="auto" w="full" flexWrap="wrap" gap={2} as="form" onSubmit={handleSubmit(onSubmit)}>
            <Flex flexDir="column" gap={1}>
              <Text color="gray.500" fontSize="sm" as="label" htmlFor="user">
                Usuário
              </Text>
              <Select id="user" placeholder="Selecione um usuário" {...register('cod_usu')}>
                {users?.data?.map((user) => (
                  <option key={user.codigo_usuario} value={user.codigo_usuario}>
                    {user.nome_usuario}
                  </option>
                ))}
              </Select>
            </Flex>

            <Flex flexDir="column" gap={1}>
              <Text color="gray.500" fontSize="sm" as="label" htmlFor="codprod">
                Código do Produto
              </Text>
              <Input {...register('cod_prod')} id="codprod" type="text" placeholder="Código do Produto" />
            </Flex>
            <Button isLoading={isRefetching} type="submit">
              Buscar
            </Button>
          </Flex>

          <TableContainer w="100%">
            <T.Table>
              <T.Thead>
                <T.Tr>
                  <T.Th />
                  <T.Th>Código</T.Th>
                  <T.Th>Produto</T.Th>
                  <T.Th>Usuário</T.Th>
                  <T.Th>Data de Cadastro</T.Th>
                </T.Tr>
              </T.Thead>
              <T.Tbody>
                <ListHistoryRegisterProduct list={data} />
              </T.Tbody>
            </T.Table>
          </TableContainer>
        </VStack>
      </Layout>
    </>
  )
}
